import Configs from "../config";
import { INoteCategory } from "../types/NoteCategory";
import { DefaultResponse } from "../types/UtilTypes";
import { localStorageGetItem } from "../utils/LocalStorage";

const create = async (body: Omit<INoteCategory, "userUid">) => {
  const userUid = localStorageGetItem("USER_UID");
  const token = localStorageGetItem("USER_TOKEN");
  const response = await fetch(`${Configs.SERVER_URL}/noteCategory`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify({ ...body, userUid }),
  });

  const category: DefaultResponse<INoteCategory> = await response.json();
  if (category.status === "ok") {
    return category.data as INoteCategory;
  }

  throw new Error(category.code);
};

const update = async (body: INoteCategory): Promise<INoteCategory> => {
  const token = localStorageGetItem("USER_TOKEN");
  const response = await fetch(`${Configs.SERVER_URL}/noteCategory`, {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      "Content-type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(body),
  });

  const tag: DefaultResponse<{ result: INoteCategory }> = await response.json();
  if (tag.status === "ok") {
    return tag.data.result as INoteCategory;
  }

  throw new Error(tag.code);
};

const readAll = async () => {
  const userUid = localStorageGetItem("USER_UID");
  const token = localStorageGetItem("USER_TOKEN");
  const response = await fetch(
    `${Configs.SERVER_URL}/noteCategory/userUid/${userUid}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );

  const category: DefaultResponse<INoteCategory[]> = await response.json();
  if (category.status === "ok") {
    return category.data as INoteCategory[];
  }

  throw new Error(category.code);
};

const remove = async (categoryId: string): Promise<INoteCategory> => {
  const token = localStorageGetItem("USER_TOKEN");
  const response = await fetch(
    `${Configs.SERVER_URL}/noteCategory/${categoryId}`,
    {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );

  const tag: DefaultResponse<INoteCategory> = await response.json();
  if (tag.status === "ok") {
    return tag.data as INoteCategory;
  }

  throw new Error(tag.code);
};

export const NoteCategoriesAPI = {
  create,
  update,
  readAll,
  remove,
};
